import React from "react";
export const Content = (props) => {
    return (React.createElement("main", null,
        React.createElement("div", { id: "reactAppContainer" }, props.children)));
};
export default Content;
